import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { VisitorTypeModifyRequest } from "../shared/VisitorTypeModifyRequest";
import { DataService_MultiStationVisitorTypeMaintenance } from "../shared/data.service";

@Component({
	selector: "app-ms-edit-visitor-type",
	templateUrl: "./ms-edit-visitor-type.component.html",
	styleUrls: ["./ms-edit-visitor-type.component.css"],
})
export class MsEditVisitorTypeComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private visitorService: DataService_MultiStationVisitorTypeMaintenance
	) {}

	ngOnInit(): void {
		this.VisitorTypeID = this.dialogConfig.data.VisitorTypeID;
		this.VisitorTypeDesc = this.dialogConfig.data.VisitorTypeDesc;
	}

	/////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////
	VisitorTypeID: number = -1;
	VisitorTypeDesc: string = "";
	errorMessage: string = "";
	Processing: boolean = false;
	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		if (this.VisitorTypeDesc == undefined || this.VisitorTypeDesc.trim().length == 0) {
			this.errorMessage = "Enter name of the visitor type";
			return;
		}

		//
		// Check Name Already Used
		//
		this.Processing = true;

		var parms: VisitorTypeModifyRequest = {
			VisitorTypeID: this.VisitorTypeID,
			VisitorTypeDesc: this.VisitorTypeDesc,
		};

		var result = this.visitorService.VisitorTypeInUse(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					this.onFinishAdd(parms);
				} else {
					this.Processing = false;

					//Fail Dialog
					this.confirmationService.confirm({
						key: "confirmedit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not create the visitor type: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onFinishAdd(parms: VisitorTypeModifyRequest) {
		var result = this.visitorService.VisitorTypeUpdate(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Visitor Type was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the visitor type: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////
	IsLoading() {
		return this.Processing == true;
	}
	/////////////////////////////////////////////////////////
}
